module.exports = __webpack_public_path__ + "af74f1a7078ef1c814cccbb8a5fa34d9.png";